import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { McTable } from "@maersk-global/mds-react-wrapper/components-core/mc-table";
import { McCheckbox } from "@maersk-global/mds-react-wrapper/components-core/mc-checkbox";
import { McMultiSelect } from "@maersk-global/mds-react-wrapper/components-core/mc-multi-select";
import { McOption } from "@maersk-global/mds-react-wrapper/components-core/mc-option";
import { McInput } from "@maersk-global/mds-react-wrapper/components-core/mc-input";
import { McIcon, McLoadingIndicator, McSelect } from "@maersk-global/mds-react-wrapper/icons";
import {
  McTag,
  McTextAndIcon,
  McTooltip,
} from "@maersk-global/mds-react-wrapper";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";

import { McPagination } from "@maersk-global/mds-react-wrapper/components-core/mc-pagination";
import { useStore } from "../../../store/store.context";
import { generateColumns, updateHeaders } from "./table-column-helper";
import { getComparator, parseStrToInt } from "../../../utils/helper";
import { API_URL, CORE_URL } from "../../../services/api-config";
import { CASE_STATUS_ID_MAP, CASE_REJECT_REASON_OPTIONS } from "../../../constants/case-status";
import {
  EMPTY_POP,
  validateBlNumber as validateBlNumberUtil,
  getFilledPopFieldsCount,
  isPaymentFormChanged as isPaymentFormChangedUtil,
  isPopDocChanged as isPopDocChangedUtil,
  fetchPaymentProofData as fetchPaymentProofDataUtil,
  buildPaymentProofPayload,
  fetchFreshPopId,
} from "../../../utils/payment-proof-helpers";
import { getWeek } from "date-fns";
import {
  renderBlNumber,
  renderCaseRespondedAt,
  renderCaseStatus,
  renderCaseStatusReason,
  renderCaseTat,
  renderdacaseprocessingtime,
  renderDate,
  renderOutcome,
  //renderTargetSla,
  renderSlaRemainingTime,
  renderSlaStatus,
  renderTimeInhour,
} from "./table-cell-helper";

import "./custom-table.scss";
import axios from "axios";
import MessagesModal from "../../shared/MessagesModal"; 
import NextStepModal from "../../shared/NextStepModal";

const CustomTable = ({ headers, rows, tableType, paginationHeader,validationcount }) => {
  const { updateStore, store } = useStore();
  const rowsPerPage = 15;
  const isValidationTable = tableType === "validation";
  const areStringArraysEqual = (left = [], right = []) => (
    left.length === right.length && left.every((value, index) => value === right[index])
  );
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [bulkSelection , setBulkSelection] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [manualComment, setManualComment] = useState("");
  const [caseaccuracyResponse, setCaseaccuracyResponse] = useState(null);
  const [caseaccuracyLoading, setCaseaccuracyLoading] = useState(false);
  const ruleNames = useMemo(() => {
    return Array.from(new Set((rows || [])
      .filter(v => (v?.rulename || '').trim())
      .map(v => String(v.rulename).trim())));
  }, [rows]);
  // Ensure at least one default reason is available and selected for 'Inaccurate'
  const DEFAULT_REASON = 'Other';
  const ruleNamesWithDefault = useMemo(() => {
    const s = new Set(ruleNames);
    s.add(DEFAULT_REASON);
    return Array.from(s);
  }, [ruleNames]);
  const updatedUserInfo = typeof window !== 'undefined' ? sessionStorage.getItem('userInfo') : null;
  let parsedUserInfo = {};
  try {
    parsedUserInfo = updatedUserInfo ? JSON.parse(updatedUserInfo) : {};
  } catch (e) {
    parsedUserInfo = {};
  }
  const defaultUserEmail = (parsedUserInfo?.email || parsedUserInfo?.userEmail || "");
  const [userAssign, setUserAssign] = useState(defaultUserEmail);
  const [assignOwnerModel, setAssignOwnerModel] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [tableResetKey, setTableResetKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedRows, setExpandedRows] = useState({});
  const [returningLoading, setReturningLoading] = useState(false);
  // initialize selectedCountries from global store if present (now an array)
  // Ensure it's always an array of strings
  const initSelectedCountries = () => {
    const stored = store.selectedCountries;
    if (Array.isArray(stored) && stored.length > 0 && typeof stored[0] === 'string') {
      return stored;
    }
    return [];
  };
  const [selectedCountries, setSelectedCountries] = useState(initSelectedCountries);
  const [countryOptions, setCountryOptions] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  // Internal search state (used when country filter + case summary query are active)
  const [searchText, setSearchText] = useState("");
  const multiSelectRef = useRef(null);
  // Case Assigned To filter state
  const initSelectedAssignees = () => {
    const stored = store.selectedAssignees;
    if (Array.isArray(stored) && stored.length > 0 && typeof stored[0] === 'string') {
      return stored;
    }
    return [];
  };
  const [selectedAssignees, setSelectedAssignees] = useState(initSelectedAssignees);
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [isAssigneeInitialized, setIsAssigneeInitialized] = useState(false);
  const assigneeMultiSelectRef = useRef(null);
  // Unread message modal state
  const [unreadModalOpen, setUnreadModalOpen] = useState(false);
  const [unreadModalData, setUnreadModalData] = useState(null);
  const [preNavModalOpen, setPreNavModalOpen] = useState(false);
  const [preNavCheckingAfrStatus, setPreNavCheckingAfrStatus] = useState(false);
  const [preNavSelectedAction, setPreNavSelectedAction] = useState("");
  const [preNavRejectReasons, setPreNavRejectReasons] = useState([]);
  const [preNavCustomRejectText, setPreNavCustomRejectText] = useState("");
  const [preNavComments, setPreNavComments] = useState("");
  const [pendingCaseNavigation, setPendingCaseNavigation] = useState(null);
  const skipPreNavClosedNavigationRef = useRef(false);
  const emptyPreNavPop = EMPTY_POP;
  const [preNavLoadingPaymentProof, setPreNavLoadingPaymentProof] = useState(false);
  const [preNavSharedBlNumber, setPreNavSharedBlNumber] = useState("");
  const [preNavSharedInvoiceNumber, setPreNavSharedInvoiceNumber] = useState("");
  const [preNavSharedBlNumberError, setPreNavSharedBlNumberError] = useState("");
  const [preNavOriginalSharedBl, setPreNavOriginalSharedBl] = useState("");
  const [preNavOriginalSharedInvoice, setPreNavOriginalSharedInvoice] = useState("");
  const [preNavPopDocuments, setPreNavPopDocuments] = useState([{ ...emptyPreNavPop }]);
  const [preNavOriginalPopDocuments, setPreNavOriginalPopDocuments] = useState([{ ...emptyPreNavPop }]);
  const [preNavUpdatingStatus, setPreNavUpdatingStatus] = useState(false);
  const [preNavRevalidating, setPreNavRevalidating] = useState(false);
  const [preNavConfirmStep, setPreNavConfirmStep] = useState(null); // null | confirm | comments
  const [preNavPendingStatusKey, setPreNavPendingStatusKey] = useState(null);
  const [preNavRevalidateStatusMsg, setPreNavRevalidateStatusMsg] = useState(null);

  // Draggable column reorder state — persisted in store across navigations
  const initColumnOrder = () => {
    const stored = store.columnOrder;
    if (Array.isArray(stored) && stored.length > 0 && typeof stored[0] === 'string') {
      return stored;
    }
    return [];
  };
  const [columnOrder, setColumnOrder] = useState(initColumnOrder);
  const [draggedColumn, setDraggedColumn] = useState(null);
  const [dragOverColumn, setDragOverColumn] = useState(null);


  const totalPages = Math.ceil(tableRows.length / rowsPerPage);

  useEffect(() => {
    if (tableType === 'validation') {
      return;
    }

    if (rows && rows.length > 0) {
      const uniqueCountries = [...new Set(rows.map(row => row.country).filter(Boolean))];
      if (!areStringArraysEqual(countryOptions, uniqueCountries)) {
        setCountryOptions(uniqueCountries);
      }
      
      // Initialize with all countries only once on first load
      if (uniqueCountries.length > 0 && !isInitialized) {
        // Ensure we're checking for valid array of strings
        const hasValidStored = Array.isArray(store.selectedCountries) && 
                               store.selectedCountries.length > 0 && 
                               typeof store.selectedCountries[0] === 'string';
        
        const defaultCountries = hasValidStored ? store.selectedCountries : uniqueCountries;
        if (!areStringArraysEqual(selectedCountries, defaultCountries)) {
          setSelectedCountries(defaultCountries);
        }
        if (!areStringArraysEqual(store.selectedCountries || [], defaultCountries)) {
          updateStore({ selectedCountries: defaultCountries });
        }
        setIsInitialized(true);
      }

      // Populate Case Assigned To options
      const uniqueAssignees = [...new Set(rows.map(row => row.caseassignedto).filter(Boolean))];
      if (!areStringArraysEqual(assigneeOptions, uniqueAssignees)) {
        setAssigneeOptions(uniqueAssignees);
      }

      if (uniqueAssignees.length > 0 && !isAssigneeInitialized) {
        const hasValidStoredAssignees = Array.isArray(store.selectedAssignees) &&
          store.selectedAssignees.length > 0 &&
          typeof store.selectedAssignees[0] === 'string';

        const defaultAssignees = hasValidStoredAssignees ? store.selectedAssignees : [];
        if (!areStringArraysEqual(selectedAssignees, defaultAssignees)) {
          setSelectedAssignees(defaultAssignees);
        }
        if (!areStringArraysEqual(store.selectedAssignees || [], defaultAssignees)) {
          updateStore({ selectedAssignees: defaultAssignees });
        }
        setIsAssigneeInitialized(true);
      }
    }
  }, [rows, tableType, isInitialized, isAssigneeInitialized, countryOptions, assigneeOptions, selectedCountries, selectedAssignees, store.selectedCountries, store.selectedAssignees]);

  // Sync local assignee state when the store is externally cleared (e.g., back to prompts / new prompt)
  useEffect(() => {
    if (Array.isArray(store.selectedAssignees) && store.selectedAssignees.length === 0 && selectedAssignees.length > 0) {
      setSelectedAssignees([]);
      setIsAssigneeInitialized(false);
    }
  }, [store.selectedAssignees]);

  // Attach event listener to McMultiSelect Web Component
  useEffect(() => {
    // Delay to ensure Web Component is fully initialized
    const timer = setTimeout(() => {
      const multiSelect = multiSelectRef.current;
      
      if (multiSelect) {
        const handleChange = (e) => {
          
          let selectedValues = [];
          
          // PRIORITY: e.target.value has the correct string array
          if (e.target && e.target.value) {
            selectedValues = Array.isArray(e.target.value) 
              ? e.target.value 
              : (typeof e.target.value === 'string' ? e.target.value.split(',').filter(Boolean) : []);
          } 
          // Fallback checks (though e.detail contains objects, not strings)
          else if (typeof e.detail === 'string') {
            selectedValues = e.detail.split(',').filter(Boolean);
          } else if (Array.isArray(e.detail)) {
            // e.detail returns objects, so we need to extract value property
            selectedValues = e.detail.map(item => typeof item === 'string' ? item : item.value).filter(Boolean);            
          }          
          
          setSelectedCountries(selectedValues);
          updateStore({ selectedCountries: selectedValues });
        };

        const handleClick = () => {};

        // Try all possible event names
        const eventNames = ['optionselected', 'mcOptionSelected', 'input', 'change', 'valueChange'];
        
        eventNames.forEach(eventName => {
          multiSelect.addEventListener(eventName, handleChange);
        });
        
        multiSelect.addEventListener('click', handleClick, true);

        return () => {
          eventNames.forEach(eventName => {
            multiSelect.removeEventListener(eventName, handleChange);
          });
          multiSelect.removeEventListener('click', handleClick, true);
        };
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [updateStore, countryOptions]);

  // Attach event listener to Case Assigned To McMultiSelect Web Component
  useEffect(() => {
    const timer = setTimeout(() => {
      const multiSelect = assigneeMultiSelectRef.current;
      if (multiSelect) {
        const handleChange = (e) => {
          let selectedValues = [];
          if (e.target && e.target.value) {
            selectedValues = Array.isArray(e.target.value)
              ? e.target.value
              : (typeof e.target.value === 'string' ? e.target.value.split(',').filter(Boolean) : []);
          } else if (typeof e.detail === 'string') {
            selectedValues = e.detail.split(',').filter(Boolean);
          } else if (Array.isArray(e.detail)) {
            selectedValues = e.detail.map(item => typeof item === 'string' ? item : item.value).filter(Boolean);
          }
          setSelectedAssignees(selectedValues);
          updateStore({ selectedAssignees: selectedValues });
        };

        const eventNames = ['optionselected', 'mcOptionSelected', 'input', 'change', 'valueChange'];
        eventNames.forEach(eventName => {
          multiSelect.addEventListener(eventName, handleChange);
        });

        return () => {
          eventNames.forEach(eventName => {
            multiSelect.removeEventListener(eventName, handleChange);
          });
        };
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [updateStore, assigneeOptions]);

  useEffect(() => {
    if (rows && rows.length > 0) {
      let filteredRows = rows;
      // Exclude approved and rejected cases in case summary view (unless user clicked those count cards)
      const isCaseSummaryView = store.isCaseSummaryView;
      const dashStatus = (store.dashboardStatus || '').toLowerCase();
      if (isCaseSummaryView && dashStatus !== 'approved' && dashStatus !== 'rejected' && dashStatus !== 'non-afr') {
        filteredRows = filteredRows.filter(r => {
          const s = (r.casestatus || '').toLowerCase();
          return s !== 'approved' && s !== 'rejected' && s !== 'non-afr';
        });
      }
      // Filter by selected countries (if any are selected and data has country info)
      if (selectedCountries.length > 0 && rows.some(r => r.country)) {
        filteredRows = filteredRows.filter(r => selectedCountries.includes(r.country));
      }
      // Filter by selected assignees
      if (selectedAssignees.length > 0 && filteredRows.some(r => r.caseassignedto)) {
        filteredRows = filteredRows.filter(r => selectedAssignees.includes(r.caseassignedto));
      }
      if (searchText && searchText.trim() !== "") {
        const q = searchText.trim().toLowerCase();
        filteredRows = filteredRows.filter(r => Object.values(r).some(v => v && String(v).toLowerCase().includes(q)));
      }
      setCurrentPage(1);
      setTableRows(filteredRows);
      setSelectAll(false);
      if (tableType !== 'validation') {
        const countryChanged = !areStringArraysEqual(store.selectedCountries || [], selectedCountries);
        const assigneeChanged = !areStringArraysEqual(store.selectedAssignees || [], selectedAssignees);
        if (countryChanged || assigneeChanged) {
          updateStore({ selectedCountries, selectedAssignees });
        }
      }
    } else {
      setTableRows(rows || []);
    }
  }, [rows, selectedCountries, selectedAssignees, searchText, store.isCaseSummaryView, store.dashboardStatus, store.selectedCountries, store.selectedAssignees, tableType]);

  useEffect(() => {
if(tableType === 'validation'){
  setCaseaccuracyLoading(true);


  fetchData()
}

  },[tableType])

  // When returning from case details, apply any status updated in store to the table row
  useEffect(() => {
    if (tableType === 'validation') return;
    // Skip if navigating INTO a case (initialCaseSelect=true); this effect is only for RETURNING
    if (store.initialCaseSelect) return;
    const updatedCaseId = store && store.caseId;
    const updatedStatus = (store && store.detailsStatus ? String(store.detailsStatus).trim() : "");
    if (!updatedCaseId || !updatedStatus) return;

    setReturningLoading(true);

    const isCaseSummaryCtx = store.isCaseSummaryView;
    const updatedStatusLower = updatedStatus.toLowerCase();
    const isApprovedOrRejected = updatedStatusLower === 'approved' || updatedStatusLower === 'rejected';

    setTableRows(prev => {
      // In case summary context, remove the row entirely if its new status is approved/rejected
      if (isCaseSummaryCtx && isApprovedOrRejected) {
        return prev.filter(row => row.casenumber !== updatedCaseId);
      }
      return prev.map(row => {
        if (row.casenumber === updatedCaseId) {
          return {
            ...row,
            casestatus: updatedStatus,
            modifiedby: store.lastModifiedBy || row.modifiedby
          };
        }
        return row;
      });
    });

    // Clear the transient status to avoid affecting subsequent case selections
    updateStore({ detailsStatus: "" });
    // Turn off the brief loading state after page jump effect runs
    setTimeout(() => setReturningLoading(false), 500);
  }, [store.caseId, store.detailsStatus, store.lastModifiedBy, store.initialCaseSelect, store.isCaseSummaryView]);

  // After rows and filters settle post-navigation, jump to the updated case's page
  useEffect(() => {
    const updatedCaseId = store && store.caseId;
    if (!updatedCaseId) return;

    setReturningLoading(true);
    const timer = setTimeout(() => {
      const idx = tableRows.findIndex(r => r.casenumber === updatedCaseId);
      if (idx >= 0) {
        const page = Math.floor(idx / rowsPerPage) + 1;
        setCurrentPage(page);
      }
      setReturningLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [store.caseId, tableRows, rowsPerPage]);


  const fetchData = async () => {
      const caseNumber = (rows && rows[0] && (rows[0].casenumber || rows[0].case_number))
    || (visibleRows && visibleRows[0] && visibleRows[0].casenumber)
    || (tableRows && tableRows[0] && tableRows[0].casenumber)
    || (store && store.caseId);

  if (!caseNumber) return;
  
return axios.get(`${API_URL}/caseaccuracy/${caseNumber}`).then((response) => {
    const dataRows = response?.data?.body?.data || [];
    const latest = dataRows && dataRows.length > 0
      ? dataRows[dataRows.length - 1]
      : null;
    const accRaw = latest?.accuracy_prnt ?? latest?.accuracy ?? null;
    const acc = accRaw != null ? String(accRaw).toLowerCase() : null;
    setCaseaccuracyResponse(acc);
  }).catch((err) => {
    console.error('Failed to fetch case accuracy:', err);
    setCaseaccuracyResponse(null);
  }).finally(() => {
    setCaseaccuracyLoading(false);
  });

  }

  // Keep 'Other' as a selectable option; no auto-selection

  const hasDates = useMemo(() => {
    return rows?.some((row) => row.createddate && row.casestatusdatetime);
  }, [rows]);

  const updatedHeaders = useMemo(
    () => updateHeaders(headers, hasDates),
    [headers, hasDates]
  );

  // Initialize column order when headers change — prefer stored order if available
  useEffect(() => {
    if (updatedHeaders.length > 0) {
      setColumnOrder(prev => {
        let newOrder;
        if (prev.length === 0) {
          // Check store for a previously saved order
          const stored = store.columnOrder;
          if (Array.isArray(stored) && stored.length > 0 && typeof stored[0] === 'string') {
            const validStored = stored.filter(k => updatedHeaders.some(h => h.key === k));
            const storedSet = new Set(validStored);
            const missing = updatedHeaders.map(h => h.key).filter(k => !storedSet.has(k));
            newOrder = [...validStored, ...missing];
          } else {
            newOrder = updatedHeaders.map(h => h.key);
          }
        } else {
          // Merge: keep existing order, append any new columns
          const existingSet = new Set(prev);
          const newKeys = updatedHeaders.map(h => h.key).filter(k => !existingSet.has(k));
          const validPrev = prev.filter(k => updatedHeaders.some(h => h.key === k));
          newOrder = [...validPrev, ...newKeys];
        }
        const orderChanged = !areStringArraysEqual(prev, newOrder);
        if (orderChanged) return newOrder;
        return prev;
      });
    }
  }, [updatedHeaders, store.columnOrder]);

  useEffect(() => {
    if (columnOrder.length === 0) return;
    if (!areStringArraysEqual(store.columnOrder || [], columnOrder)) {
      updateStore({ columnOrder });
    }
  }, [columnOrder, store.columnOrder, updateStore]);

  // Ordered headers based on column drag state
  const orderedHeaders = useMemo(() => {
    if (columnOrder.length === 0) return updatedHeaders;
    const headerMap = new Map(updatedHeaders.map(h => [h.key, h]));
    return columnOrder
      .filter(key => headerMap.has(key))
      .map(key => headerMap.get(key));
  }, [updatedHeaders, columnOrder]);

  // --- Drag-and-drop column reorder handlers ---
  const handleColumnDragStart = useCallback((e, key) => {
    setDraggedColumn(key);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', key);
  }, []);

  const handleColumnDragOver = useCallback((e, key) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (key !== draggedColumn) {
      setDragOverColumn(key);
    }
  }, [draggedColumn]);

  const handleColumnDrop = useCallback((e, targetKey) => {
    e.preventDefault();
    if (!draggedColumn || draggedColumn === targetKey) {
      setDraggedColumn(null);
      setDragOverColumn(null);
      return;
    }
    setColumnOrder(prev => {
      const newOrder = [...prev];
      const fromIndex = newOrder.indexOf(draggedColumn);
      const toIndex = newOrder.indexOf(targetKey);
      if (fromIndex < 0 || toIndex < 0) return prev;
      newOrder.splice(fromIndex, 1);
      newOrder.splice(toIndex, 0, draggedColumn);
      return newOrder;
    });
    setDraggedColumn(null);
    setDragOverColumn(null);
  }, [draggedColumn]);

  const handleColumnDragEnd = useCallback(() => {
    setDraggedColumn(null);
    setDragOverColumn(null);
  }, []);

  const handleResetColumnOrder = useCallback(() => {
    const defaultOrder = updatedHeaders.map(h => h.key);
    setColumnOrder(defaultOrder);
  }, [updatedHeaders]);

  const visibleRows = useMemo(() => {
    const processRow = (row) => {
      let week = null;
      if (row.createddate) {
        const createdDate = new Date(row.createddate);
        week = getWeek(createdDate);
      }

      return {
        ...row,
        week: week !== null ? week : "N/A",
      };
    };

    const processedRows = tableRows?.map(processRow);

    const sortedRows = orderBy
      ? [...processedRows].sort(getComparator(order, orderBy))
      : [...processedRows].sort(getComparator("desc", "ie_modifieddate"));

    return sortedRows.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );
  }, [order, orderBy, currentPage, rowsPerPage, tableRows, isValidationTable]);

  const handleSortChange = (e) => {
    const { column, direction } = e.detail;

    if (column === "slaremainingtime") {
      const updatedRows = [...tableRows].map((row) => ({
        ...row,
        [column]: parseStrToInt(row[column]),
      }));
      setTableRows(updatedRows);
    }
    setOrder(direction === "ascending" ? "asc" : "desc");
    setOrderBy(column);
    setCurrentPage(1); 
  };

  const isSummaryOrBacklogContext = useCallback(() => {
    const query = String(
      store?.navigationHistory?.previousView?.promptQuery || store?.promptQuery || ""
    ).toLowerCase();
    return Boolean(store?.isCaseSummaryView || query.includes("case summary"));
  }, [store?.isCaseSummaryView, store?.navigationHistory?.previousView?.promptQuery, store?.promptQuery]);

  const PRENAV_ACTION_COMPLIANT_GCSS = 'COMPLIANT-GCSS';
  const DEFAULT_PRENAV_COMPLIANT_GCSS_COMMENT = 'Marked compliant and GCSS AFR task closed';
  const PRENAV_STATUS_ID_MAP = CASE_STATUS_ID_MAP;
  const preNavReasonOptions = CASE_REJECT_REASON_OPTIONS;

  const continueToCaseDetails = useCallback((caseId, casestatus) => {
    updateStore({ caseId: caseId, initialCaseSelect: true, detailsStatus: casestatus || '' });
  }, [updateStore]);

  const resetPreNavModalState = useCallback(() => {
    setPreNavModalOpen(false);
    setPreNavCheckingAfrStatus(false);
    setPreNavSelectedAction("");
    setPreNavRejectReasons([]);
    setPreNavCustomRejectText("");
    setPreNavComments("");
    setPendingCaseNavigation(null);
    setPreNavLoadingPaymentProof(false);
    setPreNavSharedBlNumber("");
    setPreNavSharedInvoiceNumber("");
    setPreNavSharedBlNumberError("");
    setPreNavOriginalSharedBl("");
    setPreNavOriginalSharedInvoice("");
    setPreNavPopDocuments([{ ...emptyPreNavPop }]);
    setPreNavOriginalPopDocuments([{ ...emptyPreNavPop }]);
    setPreNavUpdatingStatus(false);
    setPreNavRevalidating(false);
    setPreNavConfirmStep(null);
    setPreNavPendingStatusKey(null);
    setPreNavRevalidateStatusMsg(null);
  }, []);

  const closePreNavModal = useCallback(() => {
    if (skipPreNavClosedNavigationRef.current) {
      skipPreNavClosedNavigationRef.current = false;
      return;
    }

    if (pendingCaseNavigation?.caseId) {
      updateStore({
        preselectedNextAction: "",
        preselectedNextActionMeta: null,
      });
      continueToCaseDetails(pendingCaseNavigation.caseId, pendingCaseNavigation.casestatus);
    }

    resetPreNavModalState();
  }, [continueToCaseDetails, pendingCaseNavigation, resetPreNavModalState, updateStore]);

  const togglePreNavReason = useCallback((reason) => {
    if (reason === 'Other') {
      setPreNavRejectReasons((prev) => (prev.includes('Other') ? [] : ['Other']));
      return;
    }
    setPreNavRejectReasons((prev) => (
      prev.includes(reason)
        ? prev.filter((r) => r !== reason)
        : [...prev, reason]
    ));
  }, []);

  useEffect(() => {
    const action = (preNavSelectedAction || '').toLowerCase();
    setPreNavUpdatingStatus(false);
    if (action !== 'reject' && action !== 'non-compliant') {
      setPreNavRejectReasons([]);
      setPreNavCustomRejectText('');
    }
    if (action === 'non-afr') {
      setPreNavComments('Non-AFR');
    } else if (action === PRENAV_ACTION_COMPLIANT_GCSS.toLowerCase()) {
      setPreNavComments(DEFAULT_PRENAV_COMPLIANT_GCSS_COMMENT);
    } else {
      setPreNavComments('');
    }

    if (action !== 'approve') {
      setPreNavLoadingPaymentProof(false);
      setPreNavSharedBlNumber('');
      setPreNavSharedInvoiceNumber('');
      setPreNavSharedBlNumberError('');
      setPreNavOriginalSharedBl('');
      setPreNavOriginalSharedInvoice('');
      setPreNavPopDocuments([{ ...emptyPreNavPop }]);
      setPreNavOriginalPopDocuments([{ ...emptyPreNavPop }]);
      setPreNavConfirmStep(null);
      setPreNavPendingStatusKey(null);
      setPreNavRevalidateStatusMsg(null);
    }
  }, [preNavSelectedAction]);

  useEffect(() => {
    if (!preNavRejectReasons.includes('Other')) {
      setPreNavCustomRejectText('');
    }
  }, [preNavRejectReasons]);

  const preNavSubmitDisabled = useMemo(() => {
    if (!preNavSelectedAction) return true;
    const action = preNavSelectedAction.toLowerCase();
    if (action === 'approve') {
      if (preNavLoadingPaymentProof || preNavUpdatingStatus || preNavRevalidating) return true;
      if (preNavConfirmStep === 'confirm') return true;
      if (preNavConfirmStep === 'comments' && preNavPendingStatusKey && !PRENAV_STATUS_ID_MAP[preNavPendingStatusKey]) return true;
      if (preNavSharedBlNumberError) return true;
    }
    if (action === 'reject' || action === 'non-compliant') {
      if (preNavRejectReasons.length === 0) return true;
      if (preNavRejectReasons.includes('Other') && !preNavCustomRejectText.trim()) return true;
    }
    return false;
  }, [preNavSelectedAction, preNavRejectReasons, preNavCustomRejectText, preNavLoadingPaymentProof, preNavUpdatingStatus, preNavRevalidating, preNavConfirmStep, preNavPendingStatusKey, preNavSharedBlNumberError]);

  const validatePreNavBlNumber = useCallback((value) => {
    return validateBlNumberUtil(value);
  }, []);

  const togglePreNavPopExpanded = useCallback((index) => {
    setPreNavPopDocuments((prev) =>
      prev.map((p, i) => (i === index ? { ...p, expanded: !p.expanded } : p))
    );
  }, []);

  const updatePreNavPopField = useCallback((index, field, value) => {
    setPreNavPopDocuments((prev) => prev.map((p, i) => (i === index ? { ...p, [field]: value } : p)));
  }, []);

  const isPreNavPaymentFormChanged = useCallback(() => {
    return isPaymentFormChangedUtil(preNavSharedBlNumber, preNavOriginalSharedBl, preNavSharedInvoiceNumber, preNavOriginalSharedInvoice, preNavPopDocuments, preNavOriginalPopDocuments);
  }, [preNavOriginalPopDocuments, preNavOriginalSharedBl, preNavOriginalSharedInvoice, preNavPopDocuments, preNavSharedBlNumber, preNavSharedInvoiceNumber]);

  const isPreNavPopDocChanged = useCallback((index) => {
    return isPopDocChangedUtil(index, preNavPopDocuments, preNavOriginalPopDocuments);
  }, [preNavPopDocuments, preNavOriginalPopDocuments]);

  const getPreNavFilledPopFieldsCount = useCallback((pop) => {
    return getFilledPopFieldsCount(pop);
  }, []);

  const fetchPreNavPaymentProofData = useCallback(async (caseNumber) => {
    if (!caseNumber) return;

    setPreNavLoadingPaymentProof(true);
    try {
      const paymentProofData = await fetchPaymentProofDataUtil(caseNumber, store?.authToken);

      // Helper returns null when no payment proof exists (e.g., 404).
      if (!paymentProofData) {
        setPreNavSharedBlNumber("");
        setPreNavSharedInvoiceNumber("");
        setPreNavOriginalSharedBl("");
        setPreNavOriginalSharedInvoice("");
        setPreNavSharedBlNumberError("");
        setPreNavPopDocuments([{ ...emptyPreNavPop }]);
        setPreNavOriginalPopDocuments([{ ...emptyPreNavPop }]);
        return;
      }

      const { sharedBl, sharedInvoice, popDocuments: docs } = paymentProofData;

      setPreNavSharedBlNumber(sharedBl);
      setPreNavSharedInvoiceNumber(sharedInvoice);
      setPreNavOriginalSharedBl(sharedBl);
      setPreNavOriginalSharedInvoice(sharedInvoice);
      setPreNavSharedBlNumberError("");

      setPreNavPopDocuments(docs);
      setPreNavOriginalPopDocuments(docs.map((d) => ({ ...d })));
    } catch (error) {
      if (error?.response?.status !== 404) {
        console.error('Error fetching pre-navigation payment proof data:', error?.message || error);
      }
      setPreNavSharedBlNumber("");
      setPreNavSharedInvoiceNumber("");
      setPreNavOriginalSharedBl("");
      setPreNavOriginalSharedInvoice("");
      setPreNavSharedBlNumberError("");
      setPreNavPopDocuments([{ ...emptyPreNavPop }]);
      setPreNavOriginalPopDocuments([{ ...emptyPreNavPop }]);
    } finally {
      setPreNavLoadingPaymentProof(false);
    }
  }, [store?.authToken]);

  useEffect(() => {
    const action = (preNavSelectedAction || '').toLowerCase();
    const caseNumber = String(pendingCaseNavigation?.caseId || '').trim();
    if (!preNavModalOpen || action !== 'approve' || !caseNumber) return;
    fetchPreNavPaymentProofData(caseNumber);
  }, [fetchPreNavPaymentProofData, pendingCaseNavigation?.caseId, preNavModalOpen, preNavSelectedAction]);

  const continueToCaseDetailsWithPreNavCleanup = useCallback((caseId, casestatus) => {
    skipPreNavClosedNavigationRef.current = true;
    continueToCaseDetails(caseId, casestatus);
    resetPreNavModalState();
  }, [continueToCaseDetails, resetPreNavModalState]);

  const submitPreNavCaseStatusUpdate = useCallback(async (nextStatusKey, comment) => {
    const caseNumber = String(pendingCaseNavigation?.caseId || '').trim();
    if (!caseNumber || !nextStatusKey || !PRENAV_STATUS_ID_MAP[nextStatusKey]) {
      throw new Error('Invalid status update request');
    }

    const payload = {
      casenumber: caseNumber,
      casestatusid: PRENAV_STATUS_ID_MAP[nextStatusKey],
      casestatusreason: comment || '',
      modifiedBy: defaultUserEmail,
      generateEmailPreview: false,
    };

    await axios.put(`${CORE_URL}/update_case_status`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${store.authToken}`,
      },
    });

    updateStore({
      detailsStatus: nextStatusKey,
      lastModifiedBy: defaultUserEmail,
    });
  }, [defaultUserEmail, pendingCaseNavigation?.caseId, store.authToken, updateStore]);

  const submitPreNavPaymentAndApprove = useCallback(async () => {
    const caseNumber = String(pendingCaseNavigation?.caseId || '').trim();
    if (!caseNumber) return;

    setPreNavUpdatingStatus(true);
    try {
      if (isPreNavPaymentFormChanged()) {
        const sharedFieldsChanged = (preNavSharedBlNumber !== preNavOriginalSharedBl) || (preNavSharedInvoiceNumber !== preNavOriginalSharedInvoice);
        for (let i = 0; i < preNavPopDocuments.length; i += 1) {
          const pop = preNavPopDocuments[i];
          const hasAnyField = !!(
            preNavSharedBlNumber ||
            preNavSharedInvoiceNumber ||
            pop.paymentProofRef ||
            pop.paymentProofDate ||
            pop.amountInPaymentProof ||
            pop.currencyInPaymentProof ||
            pop.beneficiaryName ||
            pop.bankAccountNumber ||
            pop.payerName ||
            pop.taxIdNumber
          );
          if (!pop.popid && !hasAnyField) continue;

          // Skip this POP if its own fields haven't changed AND shared fields haven't changed
          if (!sharedFieldsChanged && !isPreNavPopDocChanged(i)) continue;

          let currentPopid = pop.popid;
          if (!currentPopid && caseNumber) {
            currentPopid = await fetchFreshPopId(caseNumber, i, store.authToken);
          }

          const paymentPayload = buildPaymentProofPayload({
            caseNumber,
            pop,
            popid: currentPopid,
            sharedBl: preNavSharedBlNumber,
            sharedInvoice: preNavSharedInvoiceNumber,
            modifiedBy: defaultUserEmail,
          });

          await axios.put(`${API_URL}/update_proofofpayment`, paymentPayload, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${store.authToken}`,
            },
          });
        }
      }

      const blChanged = (preNavSharedBlNumber || '').trim() !== (preNavOriginalSharedBl || '').trim();
      const invChanged = (preNavSharedInvoiceNumber || '').trim() !== (preNavOriginalSharedInvoice || '').trim();
      let revalidatedCaseStatus = null;
      if (blChanged || invChanged) {
        const revalidatePayload = {
          case_number: caseNumber,
          ...(blChanged && { bill_of_lading: (preNavSharedBlNumber || '').trim() }),
          ...(invChanged && { inv_number: (preNavSharedInvoiceNumber || '').trim() }),
          refresh_scope: ['gcss'],
          modifiedby: defaultUserEmail,
          modifieddate: '',
        };
        setPreNavRevalidating(true);
        try {
          const revalRes = await axios.post(`${CORE_URL}/revalidate-dynamic-data`, revalidatePayload, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${store.authToken}`,
            },
          });
          revalidatedCaseStatus = revalRes?.data?.casestatus || null;
        } catch (err) {
          console.warn('Pre-nav revalidate failed:', err?.message || err);
        } finally {
          setPreNavRevalidating(false);
        }
      }

      setPreNavPendingStatusKey('APPROVED');
      setPreNavRevalidateStatusMsg(
        blChanged || invChanged
          ? `BL / Invoice data has been validated.${revalidatedCaseStatus ? ` Case status: ${revalidatedCaseStatus}.` : ''}`
          : 'Payment details have been saved.'
      );
      setPreNavConfirmStep('confirm');
    } catch (error) {
      console.error('Pre-nav approve flow failed:', error?.message || error);
      window.alert(error?.response?.data?.detail || 'Failed to process approve flow.');
    } finally {
      setPreNavUpdatingStatus(false);
    }
  }, [defaultUserEmail, isPreNavPaymentFormChanged, isPreNavPopDocChanged, pendingCaseNavigation?.caseId, preNavOriginalSharedBl, preNavOriginalSharedInvoice, preNavPopDocuments, preNavSharedBlNumber, preNavSharedInvoiceNumber, store.authToken]);

  const handlePreNavContinue = useCallback(() => {
    if (preNavSubmitDisabled) return;
    const action = (preNavSelectedAction || '').toLowerCase();

    if (action === 'approve') {
      if (preNavConfirmStep === 'confirm') return;
      if (preNavSharedBlNumberError) {
        window.alert(preNavSharedBlNumberError);
        return;
      }
      if (preNavConfirmStep === 'comments') {
        if (!pendingCaseNavigation?.caseId || !preNavPendingStatusKey) return;
        setPreNavUpdatingStatus(true);
        submitPreNavCaseStatusUpdate(preNavPendingStatusKey, preNavComments || 'AFR closed')
          .then(() => {
            continueToCaseDetailsWithPreNavCleanup(
              pendingCaseNavigation.caseId,
              preNavPendingStatusKey || 'APPROVED'
            );
          })
          .catch((err) => {
            console.error('Pre-nav approve status update failed:', err?.message || err);
            window.alert(err?.response?.data?.detail || 'Failed to update status.');
          })
          .finally(() => setPreNavUpdatingStatus(false));
        return;
      }

      submitPreNavPaymentAndApprove();
      return;
    }

    if (pendingCaseNavigation?.caseId) {
      skipPreNavClosedNavigationRef.current = true;
      updateStore({
        preselectedNextAction: action === 'approve' ? '' : preNavSelectedAction,
        preselectedNextActionMeta: {
          reasons: preNavRejectReasons,
          customReason: preNavCustomRejectText,
          comments: preNavComments,
        },
      });
      continueToCaseDetails(pendingCaseNavigation.caseId, pendingCaseNavigation.casestatus);
    }
    resetPreNavModalState();
  }, [
    continueToCaseDetailsWithPreNavCleanup,
    continueToCaseDetails,
    pendingCaseNavigation,
    preNavConfirmStep,
    preNavComments,
    preNavCustomRejectText,
    preNavPendingStatusKey,
    preNavRejectReasons,
    preNavSelectedAction,
    preNavSharedBlNumberError,
    preNavSubmitDisabled,
    submitPreNavCaseStatusUpdate,
    submitPreNavPaymentAndApprove,
    resetPreNavModalState,
    updateStore,
  ]);

  const onCaseIdClick = useCallback(
    async (caseId, casestatus) => {
      const caseNumber = String(caseId || "").trim();
      const normalizedCaseStatus = String(casestatus || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-");
      const shouldCallAfrTaskStatus =
        isSummaryOrBacklogContext() &&
        !!caseNumber &&
        ["compliant", "non-compliant", "exception"].includes(normalizedCaseStatus);

      if (shouldCallAfrTaskStatus) {
        setPreNavCheckingAfrStatus(true);
        try {
          const headers = store?.authToken
            ? { Authorization: `Bearer ${store.authToken}` }
            : undefined;
          const response = await axios.get(`${API_URL}/afr_task_status/${encodeURIComponent(caseNumber)}`, { headers });
          const taskStatus = String(
            response?.data?.body?.task_status || response?.data?.task_status || ""
          ).toUpperCase();

          if (taskStatus === 'CLOSED') {
            setPendingCaseNavigation({ caseId, casestatus });
            setPreNavSelectedAction("");
            setPreNavModalOpen(true);
            setPreNavCheckingAfrStatus(false);
            return;
          }

          setPreNavModalOpen(false);
          setPendingCaseNavigation(null);
          setPreNavCheckingAfrStatus(false);
          continueToCaseDetails(caseId, casestatus);
          return;
        } catch (error) {
          // Do not block navigation when pre-check API fails.
          console.warn("afr_task_status pre-check failed:", error?.message || error);
          setPreNavModalOpen(false);
          setPendingCaseNavigation(null);
          setPreNavCheckingAfrStatus(false);
          continueToCaseDetails(caseId, casestatus);
          return;
        }
      }

      continueToCaseDetails(caseId, casestatus);
    },
    [continueToCaseDetails, isSummaryOrBacklogContext, store?.authToken]
  );

  const handleCountryChange = useCallback((e) => {
    // McMultiSelect returns selected values in e.detail array
    const selectedOptions = e.detail || [];    
    updateStore({ selectedCountries: selectedOptions });
  }, [updateStore]);

  const onSelectRow = (e, id) => {
    const updatedRows = [...tableRows];
    const index = updatedRows.findIndex((row) => row.casenumber === id);

    if (index >= 0) {
      updatedRows[index].select = !updatedRows[index].select;
    }

    const newSelectedRows = updatedRows.filter((row) => row.select);
    setRowsSelected(newSelectedRows);
    setSelectAll(updatedRows.length === newSelectedRows.length);
    setTableRows(updatedRows);
  };

  const onSelectAllRows = (e) => {
    const isChecked = e.target.checked;
    const updatedRows = tableRows.map((row) => ({
      ...row,
      select: isChecked,
    }));

    const newSelectedRows = isChecked ? updatedRows : [];
    setRowsSelected(newSelectedRows);
    setSelectAll(isChecked);
    setTableRows(updatedRows);
  };

  const renderCaseNumber = (row, header) => (
    <span
      className="case-number-display"
      onClick={() => onCaseIdClick(row[header.key], row.casestatus)}
    >
      {row.casenumber}
    </span>
  );

  const handleToggleExpand = useCallback((rowKey) => {
    setExpandedRows((prev) => {
      const newState = {
        ...prev,
        [rowKey]: !prev[rowKey],
      };
      return newState;
    });
  }, []);

  const renderExpandableColumn = useCallback((row, columnKey) => {
    if (!row?.[columnKey]) return <span>-</span>;

    const entries = row[columnKey].split(";").filter(Boolean);
    const rowKey = `${getKeyForRow(row)}_${columnKey}`;
    const isExpanded = expandedRows[rowKey] || false;

    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleToggleExpand(rowKey);
    };

    return (
      <div>
        {entries.length > 1 ? (
          <div className="custom-cell-display">
            <div className="tag-icon-cell-wrapper">
              <div>{entries[0]}</div>
              <div 
                onClick={handleClick}
                onMouseDown={handleClick}
                style={{ display: "inline-block", cursor: "pointer" }}
              >
                <McTag
                  appearance="success"
                  slot="trigger"
                >
                  {isExpanded ? (
                    <McIcon icon="chevron-up" size="20" />
                  ) : (
                    <McTextAndIcon
                      label={entries.length - 1}
                      icon="plus"
                      size="16"
                    />
                  )}
                </McTag>
              </div>
            </div>

            {isExpanded &&
              entries
                .slice(1)
                .map((entry, index) => <div key={index}>{entry}</div>)}
          </div>
        ) : (
          <div>{entries[0]}</div>
        )}
      </div>
    );
  }, [expandedRows, handleToggleExpand]);

  const renderRemarksColumn = (row, columnKey) => {
    const value = row?.[columnKey];
    if (!value) return null;

    const rowKey = `${getKeyForRow(row)}_${columnKey}`;
    const isExpanded = expandedRows[rowKey] || false;

    const toggleExpand = () => {
      setExpandedRows((prev) => ({
        ...prev,
        [rowKey]: !prev[rowKey],
      }));
    };

    const formattedRemarks = value.split("\n").map((line, idx) => (
      <p key={idx} className="remarks-line">
        {line}
      </p>
    ));

    return (
      <div className="custom-cell-display">
        <McTooltip opendelay={50} appearance="neutral-default" zindex={99999}>
          <McTag
            appearance="success"
            slot="trigger"
            style={{ cursor: "pointer", marginBottom: "4px" }}
            onClick={toggleExpand}
          >
            <McTextAndIcon
              label={isExpanded ? "hide remarks" : "show remarks"}
              trailingicon={isExpanded ? "chevron-up" : "chevron-down"}
              size="16"
            />
          </McTag>
          {!isExpanded && <span>Click to show remarks</span>}
        </McTooltip>

        {isExpanded && (
          <div className="remarks-expanded">{formattedRemarks}</div>
        )}
      </div>
    );
  };

  const renderCell = (row, header) => {
    const renderMap = {
      // select: SelectCheckBox,
      casenumber: renderCaseNumber,
      
// Email Alert column with icon, badge, and click handler
      unread_count: (row) => {
        const count = Number(row.unread_count) || 0;
        const containerStyle = {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          cursor: count > 0 ? 'pointer' : 'default',
          position: 'relative',
          marginTop: '12px'
        };

        const iconStyle = {
          color: '#707070',
          fontSize: '20px',
          position: 'relative',
          zIndex: 1
        };

        const badgeStyle = {
          position: 'absolute',
          top: '6px',
          right: '32px',
          minWidth: '18px',
          height: '18px',
          padding: '0 5px',
          borderRadius: '9px',
          backgroundColor: '#25D366',
          color: 'white',
          display: count > 0 ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 600,
          zIndex: 2
        };

        const shownCount = count > 99 ? '99+' : String(count);
        const titleText = count > 0 ? `${count} unread message${count !== 1 ? 's' : ''}` : 'Last message';
        
        // Check if this case has any messages (including read messages)
        const hasAnyMessage = (count > 0) || Boolean(row.has_messages) || Boolean(row.last_message_time) || Boolean(row.from) || Boolean(row.subject) || Boolean(row.to) || Boolean(row.sender_mail_address) || Boolean(row.to_recipients);
        if (!hasAnyMessage) {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <span>-</span>
            </div>
          );
        }

        return (
          <div
            style={containerStyle}
            title={titleText}
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              
              const caseNumber = row.casenumber;
              if (!caseNumber) return;
              
              try {
                const response = await axios.get(`${API_URL}/get_case_messages?casenumber=${caseNumber}`);
                const messages = response.data?.messages || [];
                
                setUnreadModalData({
                  casenumber: caseNumber,
                  messages: messages,
                  unread_count: count
                });
                setUnreadModalOpen(true);
                
                // If there were unread messages, mark them as read in backend and update UI to remove badge count
                if ((messages || []).some(m => m.unread)) {
                  try {
                    const markResp = await fetch(`${API_URL}/mark_case_messages_read`, {
                      method: 'PUT',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ casenumber: caseNumber })
                    });
                    if (markResp.ok) {
                      // Update local tableRows state to remove unread_count for this case only (keep icon and message indicators)
                      setTableRows(prev => prev.map(c => {
                        if (c.casenumber === caseNumber) {
                          // Preserve message-related fields to keep icon visible
                          return { 
                            ...c, 
                            unread_count: 0,
                            // Ensure at least one message field is set so icon remains visible
                            last_message_time: c.last_message_time || messages[0]?.receive_timestamp || messages[0]?.createddate || new Date().toISOString(),
                            has_messages: true // Flag to indicate messages exist
                          };
                        }
                        return c;
                      }));
                    } else {
                      console.error('Failed to mark messages read', markResp.status);
                    }
                  } catch (err) {
                    console.error('Error marking messages read', err);
                  }
                }
              } catch (error) {
                console.error('Error fetching messages:', error);
                alert('Failed to fetch messages');
              }
            }}
          >
            <div style={badgeStyle} aria-hidden={false}>{shownCount}</div>
            <McIcon icon="comment-dots" style={iconStyle} />
          </div>
        );
      },
      // Custom BL number renderer to handle many BLs
      blnumber: (row, header) => {
        const value = row?.blnumber;
        if (!value) return <span>-</span>;
        // Support both array and string (from helper)
        const entries = Array.isArray(value) ? value : String(value).split(';').map(e => e.trim()).filter(Boolean);
        const isExpanded = expandedRows[`${row.casenumber}_blnumber`] || false;
        const toggleExpand = () => {
          setExpandedRows(prev => ({
            ...prev,
            [`${row.casenumber}_blnumber`]: !prev[`${row.casenumber}_blnumber`],
          }));
        };
        if (entries.length <= 3) {
          return (
            <div className="blnumber-cell" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
              {entries.map((entry, idx) => (
                <span key={idx} style={{ display: 'inline-block', marginRight: '4px' }}>{entry}</span>
              ))}
            </div>
          );
        }
        return (
          <div className="custom-cell-display blnumber-cell" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
            <div style={{ display: 'inline' }}>
              {entries.slice(0, 3).map((entry, idx) => (
                <span key={idx} style={{ display: 'inline-block', marginRight: '4px' }}>{entry}</span>
              ))}
              <McTag
                appearance="success"
                slot="trigger"
                style={{ cursor: "pointer", marginLeft: "4px" }}
                onClick={toggleExpand}
              >
                {isExpanded ? (
                  <McIcon icon="chevron-up" size="16" />
                ) : (
                  <McTextAndIcon
                    label={entries.length - 3}
                    icon="plus"
                    size="14"
                  />
                )}
              </McTag>
            </div>
            {isExpanded && (
              <div style={{ marginTop: "4px" }}>
                {entries.slice(3).map((entry, idx) => (
                  <div key={idx} style={{ display: 'block', marginBottom: '2px' }}>{entry}</div>
                ))}
              </div>
            )}
          </div>
        );
      },
      casestatus: renderCaseStatus,
      slastatus: renderSlaStatus,
      casestatusreason: renderCaseStatusReason,
      casetat: renderCaseTat,
      slaremainingtime: renderSlaRemainingTime,
      email_subject: (row, header) => <span>{row["email_subject"] || "-"}</span>,
    modifiedby: (row, header) => <span>{row["modifiedby"] || "-"}</span>,
    // modifieddate: renderDate,
    ie_modifieddate: renderDate,
      dacaseprocessingtime: renderdacaseprocessingtime,
      casereceiveddatetime: renderDate,
      casestatusdatetime: renderCaseRespondedAt,
      createddate: renderDate,
  //targetsla: renderTargetSla,
      countryslatime: renderTimeInhour,
      remarks: (row) => renderRemarksColumn(row, "remarks"),
  // customername removed
      //for validation table
      outcome: renderOutcome,
      bookingdata: (row) => renderExpandableColumn(row, "bookingdata"),
      afrdata: (row) => renderExpandableColumn(row, "afrdata"),
      reason : (row) => renderExpandableColumn(row, "reason"),
    };

    const renderFunction =
      renderMap[header.key] ||
      ((row, header) => <span>{row[header.key]}</span>);

    return renderFunction(row, header);
  };

  const SelectCheckBox = (row) => (
    <div key={`${row.casenumber}_select`} slot={`${row.casenumber}_select`}>
      <McCheckbox
        label=""
        name="disclaimer"
        checked={row.select}
        change={(e) => onSelectRow(e, row.casenumber)}
      />
    </div>
  );

  const SelectAllCheckbox = () => (
    <div key={`selectAll_select`} slot={`${"select"}_header`}>
      <McCheckbox
        label=""
        name="disclaimer"
        checked={selectAll}
        change={(e) => onSelectAllRows(e)}
      />
    </div>
  );

  const getKeyForRow = (row, index = 0) => {
    if (isValidationTable) {
      return `${row?.casenumber || row?.case_number || "case"}_${row?.rule_iteration || 0}_${row?.priority || 0}_${row?.rulename || row?.id || index}`;
    }
    return row?.casenumber || row?.rulename || row?.id || `row_${index}`;
  };

  const TableCell = ({ row, header, hasDates, renderCell }) => {
    if (!hasDates && (header.key === "TAT" || header.key === "week")) {
      return null;
    }
    return (
      <div
        key={`${getKeyForRow(row)}_${header.key}`}
        slot={`${getKeyForRow(row)}_${header.key}`}
      >
        {renderCell(row, header)}
      </div>
    );
  };

  const renderValidationHtmlTable = () => (
    <div className="validation-table-shell">
      <table className="validation-html-table">
        <thead>
          <tr>
            {orderedHeaders.map((header) => (
              <th key={header.key}>{header.header || header.label || header.key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row, rowIndex) => (
            <tr key={getKeyForRow(row, rowIndex)}>
              {orderedHeaders.map((header) => (
                <td key={`${getKeyForRow(row, rowIndex)}_${header.key}`}>
                  {renderCell(row, header)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const caseNumberColIndex = useMemo(() => {
    const idx = orderedHeaders.findIndex((h) => h.key === "casenumber");
    return idx >= 0 ? idx + 1 : null; // nth-child is 1-based
  }, [orderedHeaders]);

  const dynamicStickyStyles = useMemo(() => {
    const stickyInfos = [];
    let cumulativeLeft = 0;
    orderedHeaders.forEach((h, i) => {
      if (h.sticky) {
        const widthMatch = `${h.width || ''}`.match(/(\d+)/);
        const widthPx = widthMatch ? parseInt(widthMatch[1], 10) : 120;
        stickyInfos.push({ nth: i + 1, left: cumulativeLeft, width: widthPx, key: h.key });
        cumulativeLeft += widthPx;
      }
    });
    if (!stickyInfos.length) return '';
    return stickyInfos
      .map(({ nth, left, key }) => `
        /* Sticky positioning for ${key} */
        .mds-table table th:nth-child(${nth}),
        .mds-table table td:nth-child(${nth}) { position: sticky !important; left: ${left}px !important; z-index: 101 !important; background: var(--main-header-bg-color, #fff) !important; }
        .mds-table table th:nth-child(${nth}) { z-index: 102 !important; }
      `)
      .join('\n');
  }, [orderedHeaders]);

  // Check if data has country information
  const hasCountryData = useMemo(() => {
    return rows && rows.length > 0 && rows.some(row => row.country);
  }, [rows]);

  // Check if the current query is for Case Summary
  const isCaseSummaryQuery = useMemo(() => {
    return !!store.isCaseSummaryView;
  }, [store.isCaseSummaryView]);

  const handleBulkRowSelection = (e) => {
    setBulkSelection(e.detail || []);
   

  }
  // Close/cancel modal without submitting any changes
  const handleCloseResultModal = () => {
    setResultModalOpen(false);
    setSelectedAction("");
    setSelectedReasons([]);
    setManualComment("");
  };

  // Explicit submit action for accuracy result
  const handleSubmitResultModal = () => {
    const normalizedAccuracy = (selectedAction || '').trim().toLowerCase();
    const rulesStr = normalizedAccuracy === 'inaccurate' ? selectedReasons.join(",") : "";
    // Guard: require at least one reason and a comment when inaccurate
    if (normalizedAccuracy === 'inaccurate') {
      const hasReasons = selectedReasons.length > 0;
      const hasComment = (manualComment || '').trim().length > 0;
      if (!hasReasons || !hasComment) {
        alert("Please select at least one reason and enter comments.");
        return;
      }
    }
    const caseNumber = (rows && rows[0] && (rows[0].casenumber || rows[0].case_number))
      || (visibleRows && visibleRows[0] && visibleRows[0].casenumber)
      || (tableRows && tableRows[0] && tableRows[0].casenumber)
      || (store && store.caseId) 
      || "";

    if (!caseNumber) {
      console.error("Case number is missing; cannot submit case accuracy.");
      alert("Case number is missing; please select a case and try again.");
      return;
    }

    const caseStatus = (visibleRows?.find(r => r.casenumber === caseNumber)?.casestatus)
      ?? (tableRows?.find(r => r.casenumber === caseNumber)?.casestatus)
      ?? (rows?.find(r => (r.casenumber === caseNumber || r.case_number === caseNumber))?.casestatus)
      ?? (store && store.detailsStatus)
      ?? (store && store.status && store.status.casestatus)
      ?? "";

    const finalCaseStatus = (caseStatus != null && String(caseStatus).trim().length > 0) ? caseStatus : 1;

    axios.post(`${API_URL}/caseaccuracy`, {
      casenumber: caseNumber,
      accuracy: normalizedAccuracy, // API expects 'accurate'/'inaccurate'
      rules: rulesStr,               // always send a string
      comment: manualComment,
      addedby: defaultUserEmail,
      casestatus: finalCaseStatus,
      validationcount: validationcount
    }).then((response) => {
      // Optimistically update banner to chosen value for instant feedback
      setCaseaccuracyResponse(normalizedAccuracy);
      // Refetch latest accuracy to confirm server state
      setCaseaccuracyLoading(true);
      return fetchData();
    }).catch((error) => {
      console.error("Error submitting case accuracy:", error);
    }).finally(() => { 
      setResultModalOpen(false);
      setSelectedAction("");
      setSelectedReasons([]);
      setManualComment("");
    });
  };


  const handleSubmitOwner = async () => {
    try {
      setAssignLoading(true);
      if (!userAssign) {
        alert("Please enter owner email.");
        return;
      }
      if (!bulkSelection || bulkSelection.length === 0) {
        alert("Please select at least one case.");
        return;
      }

      // Derive selected case numbers robustly from selection payload
      const casenumbers = bulkSelection
        .map((sel) => {
          if (typeof sel === 'number') {
            // selection likely 1-based index; try tableRows first, then visibleRows
            const fromTable = tableRows[sel - 1]?.casenumber;
            return fromTable || visibleRows[sel - 1]?.casenumber;
          }
          if (typeof sel === 'string') return sel;
          if (sel && typeof sel === 'object') return sel.casenumber;
          return null;
        })
        .filter(Boolean);

      if (!casenumbers.length) {
        alert("Unable to resolve selected case numbers.");
        return;
      }

      const payload = {
        casenumbers,
        caseassignedto: userAssign,
        caseassigneddatetime: new Date().toISOString(),
      };

      const res = await fetch(`${API_URL}/assign_case_owner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Assign failed: ${res.status} ${text}`);
      }

      setTableRows((prev) => prev.map((row) =>
        casenumbers.includes(row.casenumber)
          ? { ...row, caseassignedto: userAssign }
          : row
      ));

      // Also patch the stored previousView data so back-navigation shows the updated owner
      if (store.navigationHistory?.previousView?.data) {
        const patchedData = store.navigationHistory.previousView.data.map(row =>
          casenumbers.includes(row.casenumber) ? { ...row, caseassignedto: userAssign } : row
        );
        updateStore({
          navigationHistory: {
            ...store.navigationHistory,
            previousView: { ...store.navigationHistory.previousView, data: patchedData },
          },
        });
      }

      setAssignOwnerModel(false);
      setBulkSelection([]);
      setTableResetKey((k) => k + 1);
    } catch (err) {
      console.error("Assign owner error:", err);
      alert("Failed to assign owner. Please try again.");
    } finally {
      setAssignLoading(false);
    }
  }

  const closeAssignModal = () => {
    if (assignLoading) return;
    setAssignOwnerModel(false);
    setBulkSelection([]);
    setTableResetKey((k) => k + 1);
  };

  // Disable submit when 'Inaccurate' selected but reasons/comments missing
  const submitDisabled = (selectedAction || '').toLowerCase() === 'inaccurate' &&
    (selectedReasons.length === 0 || (manualComment || '').trim().length === 0);


     const handleExportCases = () => {
    try {
      // Determine which rows to export: selected cases first, otherwise currently visible rows
      let exportRows = [];

      if (Array.isArray(bulkSelection) && bulkSelection.length > 0) {
        const selectedCaseNumbers = bulkSelection
          .map((sel) => {
            if (typeof sel === 'number') {
              const fromTable = tableRows[sel - 1]?.casenumber;
              return fromTable || visibleRows[sel - 1]?.casenumber;
            }
            if (typeof sel === 'string') return sel;
            if (sel && typeof sel === 'object') return sel.casenumber;
            return null;
          })
          .filter(Boolean);

        const rowMap = new Map((tableRows || []).map(r => [r.casenumber, r]));
        exportRows = selectedCaseNumbers.map(cn => rowMap.get(cn)).filter(Boolean);
      } else {
        // Export all filtered rows across pages (respecting current filters)
        exportRows = Array.isArray(tableRows) ? [...tableRows] : [];
      }

      if (!exportRows || exportRows.length === 0) {
        alert("No cases available to export");
        return;
      }

      // Use displayed table headers for consistent column order
      const headersToUse = (orderedHeaders || []).filter(h => h && h.key && h.key !== 'select');
      const headerKeys = headersToUse.map(h => h.key);
      const headerTitles = headersToUse.map(h => h.label || h.key);

      const csvRows = [];
      // Prepend serial number column
      csvRows.push(["Sl No", ...headerTitles].join(","));

      const formatVal = (val) => {
        if (val == null) return '';
        if (Array.isArray(val)) return val.join('; ');
        if (typeof val === 'object') return JSON.stringify(val);
        return String(val);
      };

      exportRows.forEach((row, idx) => {
        const values = headerKeys.map((key) => {
          const raw = row[key];
          const safe = formatVal(raw).replace(/\n|\r/g, ' ');
          return `"${safe.replace(/"/g, '""')}"`;
        });
        // Prepend serial number value
        csvRows.push([String(idx + 1), ...values].join(","));
      });

      const csvData = new Blob([csvRows.join("\n")], { type: "text/csv" });
      const url = window.URL.createObjectURL(csvData);
      const link = document.createElement("a");
      link.href = url;
      link.download = "cases_export.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error('Export failed', e);
      alert('Failed to export cases.');
    }
  };

  return (
  <div className="customTableSummary" style={{ display: "flex", flexDirection: "column" }}>
      {/* Country Filter Dropdown and Search - Show for non-validation tables when country data exists */}
      {hasCountryData && countryOptions.length > 0 &&(tableType !== 'validation')  && (
        <div style={{ 
          padding: "10px", 
          backgroundColor: "#f9f9f9"
        }}>
          <div style={{ display: "flex", alignItems: "end", gap: "16px" }}>
            <McMultiSelect
              ref={multiSelectRef}
              label="Filter by Country"
              placeholder="No countries selected"
              name="countryFilter"
              value={Array.isArray(selectedCountries) && selectedCountries.length > 0 && typeof selectedCountries[0] === 'string' 
                ? selectedCountries.join(",") 
                : ""}
            >
              {countryOptions.map((country) => (
                <McOption key={country} value={country}>
                  {country}
                </McOption>
              ))}
            </McMultiSelect>
            <McMultiSelect style={{ width: "30%" }}
              ref={assigneeMultiSelectRef}
              label="Filter by Case Assigned To"
              placeholder="No assignees selected"
              name="assigneeFilter"
              value={Array.isArray(selectedAssignees) && selectedAssignees.length > 0 && typeof selectedAssignees[0] === 'string'
                ? selectedAssignees.join(",")
                : ""}
            >
              {assigneeOptions.map((assignee) => (
                <McOption key={assignee} value={assignee}>
                  {assignee}
                </McOption>
              ))}
            </McMultiSelect>
              {isCaseSummaryQuery && (
                <>
                  <McButton
                    label="Assign Case"
                    appearance="primary"
                    disabled={bulkSelection.length === 0}
                    click={() => setAssignOwnerModel(true)}
                  />

                  <McModal
                             heading="Please select the Owner to assign the case"
                             closed={closeAssignModal}
                             open={assignOwnerModel}
                             width="40vw"
                             height="40vh"
                           escapecloseactiondisabled={assignLoading}
                           backdropcloseactiondisabled={assignLoading}
                               entercloseactiondisabled={assignLoading}
                           >
                      <div className="nextActioncontent">
                             
                              
                                 <McInput
                                   hiddenlabel="true"
                                   fit="small"
                                   name="userAssign"
                                   placeholder="Enter value"
                                   value={userAssign || defaultUserEmail}
                                   input={(e) => setUserAssign(e.target.value)}
                                 />
                           
                               
                               <div className="submitButton">
                                 <McButton
                                   appearance="secondary"
                                   fit="medium"
                                   disabled={assignLoading}
                                   click={() => handleSubmitOwner()}
                                 >
                                   {assignLoading ? 'Submitting…' : 'Submit'}
                                 </McButton>
                               </div>
                             </div>
                      </McModal>
                </>
              )}
              <div style={{ marginLeft: "auto" }}>
                <McButton
                  label="Export Cases"
                  appearance="secondary"
                  click={() => handleExportCases()}
                />
              </div>
          </div>
        
          {/* Internal search box (case summary context) */}
          <div style={{ maxWidth: "100%", marginTop: "12px" }}>
            <input
              type="text"
              placeholder="Search table..."
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              style={{ width: "100%", padding: "8px", border: "1px solid #ccc", borderRadius: "4px" }}
            />
          </div>
        </div>
      )}
      
      {/* Draggable Column Reorder Bar */}
      <div className="column-reorder-bar">
        <div className="reorder-bar-header">
          <span className="reorder-label">Reorder Columns</span>
          <button className="reorder-reset-btn" onClick={handleResetColumnOrder} title="Reset to default order">Reset</button>
        </div>
        <div className="reorder-chips">
          {orderedHeaders
            .filter(h => h.key !== 'select')
            .map(header => {
              const isSticky = header.sticky;
              const isDragging = draggedColumn === header.key;
              const isDragOver = dragOverColumn === header.key;
              return (
                <div
                  key={header.key}
                  className={`reorder-chip${
                    isDragging ? ' dragging' : ''
                  }${isDragOver ? ' drag-over' : ''
                  }${isSticky ? ' sticky-chip' : ''}`}
                  draggable={!isSticky}
                  onDragStart={(e) => handleColumnDragStart(e, header.key)}
                  onDragOver={(e) => handleColumnDragOver(e, header.key)}
                  onDrop={(e) => handleColumnDrop(e, header.key)}
                  onDragEnd={handleColumnDragEnd}
                  title={isSticky ? 'Pinned column (cannot reorder)' : 'Drag to reorder'}
                >
                  {!isSticky && <span className="drag-grip">⠿</span>}
                  {isSticky && <span className="pin-icon">📌</span>}
                  <span className="chip-label">{header.header || header.label || header.key}</span>
                </div>
              );
            })}
        </div>
      </div>

      <div style={{ padding: "10px", backgroundColor: "#f9f9f9" }}>
        {isValidationTable ? (
          renderValidationHtmlTable()
        ) : (
          <McTable key={tableResetKey}
            select={isCaseSummaryQuery && tableType !== "validation"}
            selectsticky={true}
            data={visibleRows}
            columns={generateColumns(orderedHeaders)}
            datakey="casenumber"
            headersticky={true}
            recordsperpage={10}
            sortdefaultcolumnid="ie_modifieddate"
            sortchange={(e) => handleSortChange(e)}
            sortdefaultdirection="descending"
            sortdisabled={false}
            selectchange={handleBulkRowSelection}
            outerborderstyle="solid"
            fit="small"
            horizontallinestyle="solid"
            customstyles={`
              .mds-table {
                max-height: 500px;
                overflow: auto;
                display: block;
              }
              .mds-table table {
                position: relative;
              }
              .mds-table table thead th { 
                background-color: var(--main-header-bg-color, #fff) !important; 
                position: sticky !important;
                top: 0 !important;
                z-index: 100 !important;
                font-family: 'Maersk Text', Arial, sans-serif !important;
                font-size: 14px !important;
                line-height: 20px !important;
              }
              .mds-table table tr { min-height: 100px; }
              .mds-table td {
                font-family: 'Maersk Text', Arial, sans-serif !important;
                font-size: 12px !important;
                line-height: 16px !important;
              }
              .blnumber-cell { max-width: 220px; word-break: break-word; white-space: normal; }
              table th mc-checkbox{display:none;}
              ${dynamicStickyStyles}
              ${caseNumberColIndex ? `.mds-table table td:nth-child(${caseNumberColIndex}) { box-shadow: 2px 0 4px -2px rgba(0,0,0,0.15); }` : ''}
            `}
          >
          {visibleRows?.map((row, rowIndex) => (
            <React.Fragment key={getKeyForRow(row, rowIndex)}>
              {orderedHeaders.map((header) => (
                <TableCell
                  key={`${getKeyForRow(row, rowIndex)}_${header.key}`}
                  row={row}
                  header={header}
                  hasDates={hasDates}
                  renderCell={renderCell}
                />
              ))}
            </React.Fragment>
          ))}
        </McTable>
        )}
      </div>

      {paginationHeader && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <header className="support-doc-header">{paginationHeader}</header>
          {/* {returningLoading && (
            <div style={{ marginLeft: '16px' }}>
              <McLoadingIndicator label="Refreshing cases" size="small" />
            </div>
          )} */}
          {(validationcount >= 1) && (
            caseaccuracyLoading ? (
              <div style={{ marginLeft: '16px' }}>
                <McLoadingIndicator label="Loading accuracy" size="small" />
              </div>
            ) : (
              caseaccuracyResponse && (
                <div
                  className={`accuracy-banner ${(() => {
                    const v = String(caseaccuracyResponse).toLowerCase();
                    return v === 'accurate'
                      ? 'accuracy-ok'
                      : (['inaccurate', 'out_of_scope', 'non_afr'].includes(v)
                          ? 'accuracy-bad'
                          : 'accuracy-unknown');
                  })()}`}
                >
                  <span className="accuracy-title">Accuracy:</span>
                  <span className="accuracy-value">{(() => {
                    const raw = String(caseaccuracyResponse).toLowerCase();
                    if (raw === 'out_of_scope') return 'Out of scope';
                    if (raw === 'non_afr') return 'Non AFR';
                    if (raw === 'inaccurate') return 'Inaccurate';
                    if (raw === 'accurate') return 'Accurate';
                    return String(caseaccuracyResponse);
                  })()}</span>
                </div>
              )
            )
          )}
          {tableType === 'validation' && (
            <McButton
              label="Select option"
              appearance="secondary"
              fit="small"
              disabled={!validationcount }
              style={{ marginLeft: '70px', marginTop: '15px' }}
              click={() => setResultModalOpen(true)}
            />
          )}
        </div>
      )}
      
      <div className="pagination-container">
        <McPagination
          totalpages={totalPages}
          currentpage={currentPage}
          visiblepages={10}
          pagechange={(e) => setCurrentPage(e.detail)}
          fit="small"
        />
      </div>
      {preNavCheckingAfrStatus && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.75)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <McLoadingIndicator size="large" />
          <p style={{ marginTop: '15px', color: '#333', fontSize: '20px', fontWeight: 600 }}>
            Checking AFR task status...
          </p>
        </div>
      )}
      {tableType === 'validation' && (
        <McModal
          heading="Please select appropriate accuracy result"
          open={resultModalOpen}
          closed={handleCloseResultModal}
          width="40vw"
          height={(selectedAction || '').toLowerCase() === 'inaccurate' 
            ? `${Math.min(80, Math.max(40, 20 + (ruleNamesWithDefault.length * 3)))}vh` 
            : '40vh'}
        >
          <div className="nextActioncontent">
            <McSelect
              label=""
              placeholder="Select an action"
              value={selectedAction}
              optionselected={(e) => setSelectedAction(e.target.value)}
            >
              <McOption value="ACCURATE">Accurate</McOption>
              <McOption value="INACCURATE">Inaccurate</McOption>
              <McOption value="OUT_OF_SCOPE">Out of scope</McOption>
            </McSelect>

            {(selectedAction || '').toLowerCase() === 'inaccurate' && (
              <div style={{ marginTop: '12px' }}>
                <label style={{ fontSize: '16px', fontWeight: 400, display: 'block', marginBottom: '4px' }}>Reasons</label>
                <div style={{ border: '1px solid #d0d0d0', borderRadius: '4px', padding: '6px' }}>
                  {ruleNamesWithDefault.map(option => (
                      <div key={option} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                        <input
                          id={`manual-reason-${option}`}
                          type="checkbox"
                          checked={selectedReasons.includes(option)}
                          onChange={() => setSelectedReasons(prev => (
                            prev.includes(option)
                              ? prev.filter(r => r !== option)
                              : [...prev, option]
                          ))}
                          style={{ marginRight: '6px' }}
                        />
                        <label htmlFor={`manual-reason-${option}`} style={{ fontSize: '12px', cursor: 'pointer' }}>{option}</label>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {(selectedAction || '').length > 0 && (
              <div style={{ marginTop: '12px' }}>
                <label style={{ fontSize: '16px', fontWeight: 400, display: 'block', marginBottom: '4px' }}>Comments</label>
                <textarea
                  rows={4}
                  style={{ width: '100%' }}
                  name="manualValidationComment"
                  value={manualComment}
                  onChange={(e) => setManualComment(e.target.value)}
                  placeholder="Enter comments"
                />
                {(selectedAction || '').toLowerCase() === 'inaccurate' && submitDisabled && (
                  <div style={{ marginTop: '6px', color: '#d32f2f', fontSize: '12px' }}>
                    Please select at least one reason and enter comments to submit.
                  </div>
                )}
              </div>
            )}

            <div className="submitButton" style={{ marginTop: '12px' }}>
              {submitDisabled ? (
                <McTooltip opendelay={100} appearance="neutral-default" zindex={99999}>
                  <div slot="trigger">
                    <McButton
                      appearance="secondary"
                      fit="medium"
                      disabled
                      click={handleSubmitResultModal}
                    >
                      Submit
                    </McButton>
                  </div>
                  <span>Select at least one reason and enter comments.</span>
                </McTooltip>
              ) : (
                <McButton
                  appearance="secondary"
                  fit="medium"
                  click={handleSubmitResultModal}
                >
                  Submit
                </McButton>
              )}
            </div>
          </div>
        </McModal>
      )}
      <NextStepModal
        open={preNavModalOpen}
        onClose={closePreNavModal}
        width="50vw"
        height={(() => {
          const action = (preNavSelectedAction || '').toLowerCase();
          if (action === 'approve') {
            if (preNavConfirmStep === 'confirm') return '52vh';
            if (preNavConfirmStep === 'comments') return '40vh';
            return preNavPopDocuments.some((p) => p.expanded) ? '85vh' : '68vh';
          }
          if (action === PRENAV_ACTION_COMPLIANT_GCSS.toLowerCase()) return '55vh';
          if (['reject', 'non-compliant'].includes(action)) return '62vh';
          return '50vh';
        })()}
      >
        <div className="nextActioncontent">
          {preNavCheckingAfrStatus ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '200px' }}>
              <McLoadingIndicator size="large" />
            </div>
          ) : (
            <>
              <p style={{ fontSize: '13px', color: '#555', marginBottom: '10px' }}>
                AFR task status is CLOSED in GCSS for this case. Select the next step and continue.
              </p>
              <McSelect
            label=""
            placeholder="Select an action"
            value={preNavSelectedAction}
            optionselected={(e) => setPreNavSelectedAction(e.target.value)}
          >
            <McOption value="approve">Approve</McOption>
            <McOption value="NON-AFR">Non-AFR</McOption>
          </McSelect>
          {((preNavSelectedAction || '').toLowerCase() === 'reject' || (preNavSelectedAction || '').toLowerCase() === 'non-compliant') && (
            <div style={{ marginTop: '12px' }}>
              <label style={{ fontSize: '16px', fontWeight: 400, display: 'block', marginBottom: '4px' }}>Reasons</label>
              <div style={{ border: '1px solid #d0d0d0', borderRadius: '4px', padding: '6px' }}>
                {preNavReasonOptions.map((option) => (
                  <div key={option} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                    <input
                      id={`prenav-reason-${option}`}
                      type="checkbox"
                      checked={preNavRejectReasons.includes(option)}
                      onChange={() => togglePreNavReason(option)}
                      style={{ marginRight: '6px' }}
                      disabled={option !== 'Other' && preNavRejectReasons.length > 0 && preNavRejectReasons.includes('Other')}
                    />
                    <label htmlFor={`prenav-reason-${option}`} style={{ fontSize: '12px', cursor: 'pointer' }}>{option}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
          {(((preNavSelectedAction || '').toLowerCase() === 'reject' || (preNavSelectedAction || '').toLowerCase() === 'non-compliant') && preNavRejectReasons.includes('Other')) && (
            <textarea
              rows={4}
              style={{ width: '-webkit-fill-available', marginTop: '8px' }}
              name="preNavCustomRejectReason"
              value={preNavCustomRejectText}
              onChange={(e) => setPreNavCustomRejectText(e.target.value)}
              placeholder="Enter reason"
            />
          )}
          {((preNavSelectedAction || '').toLowerCase() === 'approve') && (
            <div style={{ marginTop: '16px' }}>
              {preNavConfirmStep === 'confirm' && (
                <div style={{ marginTop: '24px', padding: '24px 20px', backgroundColor: '#f0f8ff', borderRadius: '10px', border: '1px solid #90caf9', textAlign: 'center' }}>
                  <div style={{ fontSize: '32px', marginBottom: '10px' }}>✅</div>
                  <p style={{ fontSize: '15px', fontWeight: 600, color: '#1a237e', marginBottom: '6px' }}>Payment details saved successfully.</p>
                  {preNavRevalidateStatusMsg && (
                    <p style={{ fontSize: '13px', color: '#555', marginBottom: '14px' }}>{preNavRevalidateStatusMsg}</p>
                  )}
                  <p style={{ fontSize: '14px', color: '#333', marginBottom: '22px' }}>
                    Do you want to proceed and update the case status to <strong>APPROVED</strong>?
                  </p>
                  <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                    <McButton appearance="primary" fit="medium" click={() => { if (!preNavComments) setPreNavComments('AFR closed'); setPreNavConfirmStep('comments'); }}>
                      Yes, Proceed
                    </McButton>
                    <McButton appearance="neutral" variant="filled" fit="medium" click={closePreNavModal}>
                      Cancel
                    </McButton>
                  </div>
                </div>
              )}

              {preNavConfirmStep === 'comments' && (
                <div style={{ marginTop: '16px' }}>
                  <p style={{ fontSize: '13px', color: '#555', marginBottom: '6px' }}>Add any comments for this approval (optional).</p>
                  <textarea
                    rows={5}
                    style={{ width: '-webkit-fill-available', marginTop: '0px' }}
                    name="preNavApproveComments"
                    value={preNavComments || ''}
                    onChange={(e) => setPreNavComments(e.target.value)}
                    placeholder="Enter Comments for Status change"
                  />
                </div>
              )}

              {preNavConfirmStep === null && (
                <>
                  {preNavLoadingPaymentProof ? (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <McLoadingIndicator appearance="primary" />
                      <p style={{ marginTop: '8px', fontSize: '13px', color: '#666' }}>Loading payment proof details...</p>
                    </div>
                  ) : (
                    <>
                      <div style={{ marginBottom: '16px', padding: '14px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>BL Number <span style={{ color: '#999', fontSize: '12px' }}>(9 alphanumeric)</span></label>
                            <input
                              type="text"
                              value={preNavSharedBlNumber || ''}
                              onChange={(e) => {
                                setPreNavSharedBlNumber(e.target.value);
                                setPreNavSharedBlNumberError(validatePreNavBlNumber(e.target.value));
                              }}
                              style={{ width: '-webkit-fill-available', padding: '8px', border: `1px solid ${preNavSharedBlNumberError ? '#d32f2f' : '#d0d0d0'}`, borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit', backgroundColor: preNavSharedBlNumberError ? '#ffebee' : 'transparent' }}
                            />
                            {preNavSharedBlNumberError && <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px', fontWeight: 500 }}>{preNavSharedBlNumberError}</div>}
                          </div>
                          <div>
                            <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Invoice Number</label>
                            <input
                              type="text"
                              value={preNavSharedInvoiceNumber || ''}
                              onChange={(e) => setPreNavSharedInvoiceNumber(e.target.value)}
                              style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit', backgroundColor: 'transparent' }}
                            />
                          </div>
                        </div>
                      </div>

                      {preNavPopDocuments.map((pop, popIdx) => (
                        <div key={pop.popid || popIdx} style={{ marginBottom: '12px', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
                          <div style={{ padding: '16px 20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                              <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 400, color: '#141414' }}>
                                <span style={{ fontWeight: 700 }}>Proof of Payment:</span>{' '}
                                {pop.proofdocumentpath || <span style={{ color: '#999' }}>&mdash;</span>}
                              </h4>
                              {getPreNavFilledPopFieldsCount(pop) > 0 && (
                                <div style={{ backgroundColor: '#4caf50', color: 'white', borderRadius: '12px', padding: '2px 8px', fontSize: '11px', fontWeight: 600 }}>
                                  {getPreNavFilledPopFieldsCount(pop)} of 8 filled
                                </div>
                              )}
                            </div>
                            <div style={{ fontSize: '12px', color: '#555', marginBottom: '10px' }}>
                              <span style={{ fontSize: '15px', fontWeight: 700, color: pop.documenttype?.toLowerCase() === 'unqualified-pop' ? ' #EA5D4B' : '#141414' }}>Document Type : {pop.documenttype || <span style={{ color: '#999' }}>&mdash;</span>}</span>
                            </div>
                            <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
                              <div style={{ flex: 1, minWidth: '200px' }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Payer Information</div>
                                <div style={{ fontSize: '12px', color: '#555', lineHeight: 1.8 }}>
                                  <div><strong>Payer Name :</strong> {pop.payerName || <span style={{ color: '#999' }}>-</span>}</div>
                                </div>
                              </div>
                              <div style={{ flex: 1, minWidth: '200px' }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', marginBottom: '6px' }}>Beneficiary Information</div>
                                <div style={{ fontSize: '12px', color: '#555', lineHeight: 1.8 }}>
                                  <div><strong>Beneficiary Name :</strong> {pop.beneficiaryName || <span style={{ color: '#999' }}>-</span>}</div>
                                  <div><strong>Bank Account No. :</strong> {pop.bankAccountNumber || <span style={{ color: '#999' }}>-</span>}</div>
                                  <div><strong>Amount in Payment Proof :</strong> {pop.amountInPaymentProof || <span style={{ color: '#999' }}>-</span>}</div>
                                  <div><strong>Currency :</strong> {pop.currencyInPaymentProof || <span style={{ color: '#999' }}>-</span>}</div>
                                  <div><strong>File Path :</strong> {pop.proofdocumentpath || <span style={{ color: '#999' }}>-</span>}</div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            role="button"
                            tabIndex={0}
                            onClick={() => togglePreNavPopExpanded(popIdx)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePreNavPopExpanded(popIdx); } }}
                            style={{
                              cursor: 'pointer',
                              padding: '10px 16px',
                              backgroundColor: pop.documenttype?.toLowerCase() === 'unqualified-pop' ? '#FFE9E7' : '#f5f5f5',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              userSelect: 'none',
                              borderTop: '1px solid #e0e0e0',
                              borderBottom: pop.expanded ? '1px solid #e0e0e0' : 'none',
                            }}
                          >
                            <span style={{ fontSize: '13px', fontWeight: 500, color: '#333' }}>{pop.documenttype?.toLowerCase() === 'unqualified-pop' ? 'Unqualified POP' : 'Qualified POP'} {popIdx + 1}</span>
                            <svg width="18" height="18" viewBox="0 0 24 24" style={{ transform: pop.expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                              <path d="M7 10l5 5 5-5" stroke="#555" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>

                          {pop.expanded && (
                            <div style={{ padding: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', maxHeight: '50vh', overflowY: 'auto' }}>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payment Proof Ref #</label><input type="text" value={pop.paymentProofRef || ''} onChange={(e) => updatePreNavPopField(popIdx, 'paymentProofRef', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payment Proof Date</label><input type="date" value={pop.paymentProofDate || ''} onChange={(e) => updatePreNavPopField(popIdx, 'paymentProofDate', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Amount in Payment Proof</label><input type="number" step="0.01" value={pop.amountInPaymentProof || ''} onChange={(e) => updatePreNavPopField(popIdx, 'amountInPaymentProof', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Currency</label><input type="text" value={pop.currencyInPaymentProof || ''} onChange={(e) => updatePreNavPopField(popIdx, 'currencyInPaymentProof', e.target.value.toUpperCase())} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Beneficiary Name</label><input type="text" value={pop.beneficiaryName || ''} onChange={(e) => updatePreNavPopField(popIdx, 'beneficiaryName', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Bank Account Number</label><input type="text" value={pop.bankAccountNumber || ''} onChange={(e) => updatePreNavPopField(popIdx, 'bankAccountNumber', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Payer Name</label><input type="text" value={pop.payerName || ''} onChange={(e) => updatePreNavPopField(popIdx, 'payerName', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                              <div><label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '4px', color: '#555' }}>Tax ID Number / NIT</label><input type="text" value={pop.taxIdNumber || ''} onChange={(e) => updatePreNavPopField(popIdx, 'taxIdNumber', e.target.value)} style={{ width: '-webkit-fill-available', padding: '8px', border: '1px solid #d0d0d0', borderRadius: '4px', fontSize: '13px', fontFamily: 'inherit' }} /></div>
                            </div>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </div>
          )}
          {((preNavSelectedAction || '').toLowerCase() === 'compliant' ||
            (preNavSelectedAction || '').toLowerCase() === 'on-hold' ||
            (preNavSelectedAction || '').toLowerCase() === 'exception' ||
            (preNavSelectedAction || '').toLowerCase() === 'non-afr') && (
            <textarea
              rows={4}
              style={{ width: '-webkit-fill-available', marginTop: '8px' }}
              name="preNavComments"
              value={preNavComments || ''}
              onChange={(e) => setPreNavComments(e.target.value)}
              placeholder="Enter Comments for Status change"
            />
          )}
          {preNavConfirmStep !== 'confirm' && (
          <div className="submitButton" style={{ marginTop: '12px' }}>
            <McButton
              appearance="secondary"
              fit="medium"
              disabled={preNavSubmitDisabled}
              click={handlePreNavContinue}
            >
              {preNavRevalidating
                ? 'Revalidating data, please wait...'
                : preNavUpdatingStatus
                  ? 'Submitting...'
                  : preNavConfirmStep === 'comments'
                    ? 'Approve'
                    : 'Submit'}
            </McButton>
            {preNavUpdatingStatus && !preNavRevalidating && (
              <div style={{ marginTop: '8px' }}>
                <McLoadingIndicator appearance="primary" />
              </div>
            )}
            {preNavRevalidating && (
              <p style={{ fontSize: '12px', color: '#555', marginTop: '6px' }}>
                Revalidating BL / Invoice data, this may take up a few seconds...
              </p>
            )}
          </div>
          )}
            </>
          )}
        </div>
      </NextStepModal>
      <MessagesModal
        open={unreadModalOpen}
        onClose={() => setUnreadModalOpen(false)}
        caseNumber={unreadModalData?.casenumber}
        initialData={unreadModalData}
      />
    </div>
  );
};

export default CustomTable;
